import zod from 'zod'

export const CustomerTypeEnum = zod.enum(['ADMIN', 'CUSTOMER', 'PARKING'])

export const CustomerProfileEnum = zod.enum(['SUPER_ADMIN', 'ADMINISTRATOR', 'MANAGER', 'WORKER'])

export const ParkingStatusEnum = zod.enum([
  'ACTIVE',
  'REFUSED',
  'DISABLED',
  'REFUSED',
  'PENDING',
])

export const BookingStatusEnum = zod.enum([
  'PENDING',
  'ACCEPTED',
  'CANCELLED',
  'INPROGRESS',
  'REFUSED',
  'FINISHED',
])

export const KanbanTypeEnum = zod.enum(['COLUMN', 'BOOKING'])

export const VehicleTypeEnum = zod.enum(['CAR', 'BIKE', 'MOTORCYCLE'])

export const WeekDayEnum = zod.enum([
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY',
])

export const PaymentMethodEnum = zod.enum(
  [
    'CREDIT_CARD',
    'APP',
    'MONEY',
    'PIX',
    'NONSTOP',
    'DEBIT_CARD',
    'CONNECT_CAR',
  ],
  { invalid_type_error: 'empty_select' }
)
